import { useMutation } from "@tanstack/react-query";
import { checkUserExists } from "../../API/functions";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateNewUser, updateUser } from "../../redux/slices/userSlice";

export const useCheckUser = () => {
  const dispatch = useDispatch(); 
  const { mutate } = useMutation({
    mutationFn: (vars) => checkUserExists(vars),
    onSuccess: (result) => {
      if (result?.data) {
        const { user_name, user_email, profile_image, wallet_address ,email_verified} = result.data;
        dispatch(
          updateUser({
            user: user_name || "",
            email: user_email || "",
            profileImage: profile_image || "",
            isEmailVerified: email_verified || false,
            walletAddress: wallet_address || "",
          })
        );
      }
      dispatch(updateNewUser(result?.new_user  )); 
    },
    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { mutate };
};

export default useCheckUser;
